/* ===== Подключение компонентов React ===== */

/* ===== Подключение локальной Базы Данных ===== */
import Comandss from "../../../data/comands";

/* ===== Подключение локальных компонентов ===== */
import Card from "../../ui/Card/CardsSection";

/* ===== Подключение стилей ===== */
import s from "./Comands.module.scss";


function Comands() {
    return (
        <section className={s.comands}>
            <div className={`contaier ${s.container}`}>
                <div className={s.header}>
                    <h2 className={s.title}>Наша команда</h2>
                    <span className={s.description}>Эксперты, работающие для вас</span>
                </div>
                <div>
                    <Card {...Comandss} className={s.items} />
                </div>
            </div>
        </section>
    )
}

export default Comands;
